/*
 * Packages: WebVideo.RemoteWebInspector
 * Version: $Id$
 * Copyright (c) 2012 Sergey Leonov
 */

var _rwi_started = false,
    console = console || {'log': function(){}};

function RemoteWebInspector() {}

RemoteWebInspector.start = function(target) {
  if (!document.getElementById('weinre')) {
    var e = document.createElement('script');
    e.setAttribute('id','weinre');
    e.setAttribute('src','http://webvideo-devel.softservice.org:8080/target/target-script-min.js#'+target);
    document.getElementsByTagName('body')[0].appendChild(e);
  }
  _rwi_started = true;
};

RemoteWebInspector.stop = function() {
  _rwi_started = false;
};

RemoteWebInspector.restart = function() {
  _rwi_started = true;
};

RemoteWebInspector.trace = function(msg) {
  if (_rwi_started) console.log(msg);
};